/**
 * https://github.com/kalvinGit/kpopup
 * @param dom
 * @param options = {
      width: '290px',
      height: '350px',
      duration: 500,
      content: '',
      open: '',
      close: ''
    }
 */
var popup = function (dom, options) {
  var initHtml = '<div class="v-popup-mask"></div><div class="v-popup-content"></div>';
  $(dom).prepend(initHtml);
  var $popupMaskEl = $(dom).find('.v-popup-mask');
  var $popupContentEl = $(dom).find('.v-popup-content');
  var popupMaskCss = 'position: fixed;top: 0;left: 0;right: 0;bottom: 0;background: rgb(0, 0, 0); opacity: 0.5;z-index: 1001;display: none;';
  var popupContentCss = 'position: fixed;z-index: 99999;background: #fff;overflow: hidden;box-shadow: 1px 1px 50px rgba(0,0,0,.3);';
  var popupContentHideCss = 'position: fixed;z-index: 99999;background: #fff;overflow: hidden;';
  $popupMaskEl.attr('style', popupMaskCss);
  $popupContentEl.attr('style', popupContentCss);
  var top = 0,
    right = 0,
    bottom = 0,
    left = 0;
  var topCss = '',
    rightCss = '',
    bottomCss = '',
    leftCss = '';
  var width = options.width;
  var height = options.height;
  var duration = options.duration || 'fast';
  var animateInto = {};

  var content = options.content;
  renderContent();

  var unLock = null;

  this.popupRight = function () {
    width = width || '290px';
    height = height || '100%';
    topCss = bottomCss || (topCss || 'top:0;');
    rightCss = 'right: -' + width + ';';
    leftCss = '';
    animateInto.right = '-' + width;
    handlePop({
      right: right
    });
  };

  this.popupLeft = function () {
    width = width || '290px';
    height = height || '100%';
    topCss = bottomCss || (topCss || 'top:0;');
    leftCss = 'left: -' + width + ';';
    rightCss = '';
    animateInto.left = '-' + width;
    handlePop({
      left: left
    });
  };

  this.popupTop = function () {
    width = width || '350px';
    height = height || '250px';
    leftCss = rightCss || (leftCss || 'left:0;');
    topCss = 'top: -' + height + ';';
    bottomCss = '';
    animateInto.top = '-' + height;
    handlePop({
      top: top
    });
  };

  this.popupBottom = function () {
    width = width || '350px';
    height = height || '250px';
    leftCss = rightCss || (leftCss || 'left:0;');
    bottomCss = 'bottom: -' + height + ';';
    topCss = '';
    animateInto.bottom = '-' + height;
    handlePop({
      bottom: bottom
    });
  };

  this.setTop = function (t) {
    top = t;
    bottom = 0;
    topCss = 'top:' + t + 'px;';
    bottomCss = '';
    return this;
  };
  this.setRight = function (r) {
    right = r;
    left = 0;
    rightCss = 'right:' + r + 'px;';
    leftCss = '';
    return this;
  };
  this.setBottom = function (b) {
    bottom = b;
    top = 0;
    bottomCss = 'bottom:' + b + 'px;';
    topCss = '';
    return this;
  };
  this.setLeft = function (l) {
    left = l;
    right = 0;
    leftCss = 'left:' + l + 'px;';
    rightCss = '';
    return this;
  };

  function synthesisStyle() {
    return popupContentCss + topCss + rightCss + bottomCss + leftCss + 'width:' + width + ';' + 'height:' + height;
  }

  function handlePop(animate) {
    if(options.open) {
      $(options.open).on('click', function () {
        $popupMaskEl.show();
        $popupContentEl.attr('style', synthesisStyle());
        $popupContentEl.animate(animate, duration, function(){
          handleScrollBar('lock');
        });
        $popupContentEl.children(':first').show();
      });
    }

    $(dom).on('click', '.v-popup-mask', function () {
      $popupMaskEl.hide();
      $popupContentEl.animate(animateInto, duration, function () {
        $(this).children(':first').hide();
        $(this).attr('style', popupContentHideCss);
        handleScrollBar('unlock');
      });
    });

    if(options.close) {
      $(dom).on('click', options.close, function () {
        $popupMaskEl.hide();
        $popupContentEl.animate(animateInto, duration, function () {
          $(this).children(':first').hide();
          $(this).attr('style', popupContentHideCss);
          handleScrollBar('unlock');
        });
      });
    }
  }

  function renderContent() {
    $popupContentEl.html($(dom).children(content).prop('outerHTML'));
    $(dom).children(content).remove();
  }

  function handleScrollBar(type) {
    if(type === 'lock') {
      if(!unLock) {
        // console.log('lock');
        unLock = window.VUtils.lockScroll();
      }
    } else {
      if(unLock) {
        // console.log('unlock');
        unLock();
        unLock = null;
      }
    }
  }
};